/*
 * Menu Actions
 */

export const OPEN_MENU = 'OPEN_MENU'
export const CLOSE_MENU = 'CLOSE_MENU'
export const TOGGLE_MENU = 'TOGGLE_MENU'
export const SET_MENU_ITEMS = 'SET_MENU_ITEMS'
